module.exports = __webpack_public_path__ + "e3301d9a1e50ceaf25e83ba6f828adda.glb";